import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "log-list" }
const _hoisted_2 = { class: "log-content" }
const _hoisted_3 = { class: "log-span" }
const _hoisted_4 = { class: "log-span" }
const _hoisted_5 = { class: "log-span" }
const _hoisted_6 = {
  key: 0,
  class: "log-note"
}

import { Alarm, AlarmActivationType } from '@/server/MakeSenseApp-backend'
import { computed } from 'vue'
import moment from 'moment'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmLogs',
  props: {
  alarm: {
    required: true,
    type: Alarm
  }
},
  setup(__props) {

function formatType(type: AlarmActivationType | undefined) {
  if (type === undefined) {
    return ''
  }

  if (type === AlarmActivationType.Activate) {
    return 'Alarm Activated'
  } else {
    return 'Alarm Deactivated'
  }
}

function formatDate(value: Date | undefined) {
  if (value === undefined) {
    return '-'
  }
  return moment(value).format('YYYY-MM-DD hh:mm')
}

var props = __props

const sortedLogs = computed(() => {
  return (
    props.alarm?.logs
      ?.slice()
      .sort((a, b) => new Date(b.timestamp ?? 0).getTime() - new Date(a.timestamp ?? 0).getTime())
      .slice(0, 3) ?? []
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedLogs.value, (log, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "log-card mb-2 p-2"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(formatType(log.type)), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(formatDate(log.timestamp)), 1),
          _cache[0] || (_cache[0] = _createTextVNode(" by ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(log.changedBy?.name), 1)
        ]),
        (log.comment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "\"" + _toDisplayString(log.comment) + "\"", 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})